import React from 'react';
import { IconContainer } from './IconContainer';

const AuditIcon = ({small, ...props}) => {
    return (
        <IconContainer ariaLabel="audit" {...props}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10H2C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2C7.536 2 5.332 3.114 3.865 4.865L6 7H0V1L2.447 3.446C4.28 1.336 6.984 0 10 0ZM11 5V9.585L14.243 12.828L12.828 14.243L9 10.413V5H11Z" fill="white"/>
            </svg>
        </IconContainer>
    )
}

export { AuditIcon };